import { ArrowRight, ArrowUpRight } from "lucide-react";

/**
 * One arrow language for actions: → stays on the site (pages, anchors and
 * in-page dialogs), ↗ leaves it (other domains, email, feeds). SVG keeps
 * arrows consistent on devices that render text arrows as emoji.
 */
export function CtaArrow({ external = false }: { external?: boolean }) {
  const Icon = external ? ArrowUpRight : ArrowRight;
  return (
    <Icon
      aria-hidden="true"
      focusable="false"
      className="inline-block size-[1em] shrink-0 align-[-0.125em]"
    />
  );
}
